import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\HASEE\\Documents\\ChatGPT\\生产项目\\cf-migrations\\nextwork\\build\\deathstranding2-lol\\src\\components\\console\\sidebar\\nav.tsx");
